module.exports = __webpack_public_path__ + "static/img/rect-bg.b71061fb.png";